import { createActions } from 'redux-actions';
import { put } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { PLAN_ENDPOINT } from './endpoints';

const actions = createActions({
  PAYMENT: {
    GET_PLANS: undefined,
    API: {
      GET_PLANS: apiResourceActionCreator('plans')
    }
  }
})

export const apiAction = () => commonApiActions.get(PLAN_ENDPOINT, actions.payment.api.getPlans)

export function* fetchPlans(action) {
  yield put(apiAction());
}

const configuration = {
  name: 'getPlans',
  action: actions,
  sagas: fetchPlans,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      plans: action.payload.plans
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/payment/configurations/getPlans.js